(function($){
	$.fn.editor = function(opts) {
		var opts = $.extend({
			preview: false,
			preview_callback: '/preview-callback'
		}, opts);
		var shortcuts_helper = {
			ctrl_is_clicked: false,
			ctrl_keycode: 17,
			callbacks: {},
			init: function(textarea) {
				textarea.keydown(function(e) {
					return shortcuts_helper._btn_clicked(e.which);
				}).keyup(function(e) {
					return shortcuts_helper._btn_released(e.which);
				}).blur(function() {
					shortcuts_helper.ctrl_is_clicked = false;
				});
			},
			observe: function(shortcut, callback) {
				shortcuts_helper.callbacks[shortcut.toUpperCase()] = callback;
			},
			_btn_clicked: function(keycode) {
				if (keycode==shortcuts_helper.ctrl_keycode) {
					shortcuts_helper.ctrl_is_clicked = true;
				} else if (shortcuts_helper.ctrl_is_clicked) {
					var letter = String.fromCharCode(keycode);
					if (typeof shortcuts_helper.callbacks[letter] != "undefined") {
						shortcuts_helper.callbacks[letter].call();
						return false;
					}
				}
			},
			_btn_released: function(keycode) {
				if (keycode==shortcuts_helper.ctrl_keycode) {
					shortcuts_helper.ctrl_is_clicked = false;
				}
			}
		}

		this.each(function() {
			var textarea = $(this).get(0);
			if ( $(document.body).hasClass('user-type-admin') ) {
				shortcuts_helper.init($(textarea));
			}

		    if ( (document.selection == undefined) && (textarea.setSelectionRange == undefined) ) {
				return;
		    }

		    var toolbar = $("<div class='edit-toolbar'></div>");

			function addButton(id, shortcut_btn, title, fn, button_content = '') {
				if (shortcut_btn) {
					title = title + "(Ctrl + " + shortcut_btn.toUpperCase() + ")";
				}
				if (!button_content) {
					button_content = id;
				}
				var a = $('<a href="#" id="button_' + id + '" title="' + title + '" tabindex="400">' + button_content + ' </a>');

				a.click(function() {
					fn();
					return false
				});

				if (shortcut_btn) {
					shortcuts_helper.observe(shortcut_btn, function() {
						fn()
						return false;
					});
				}

				toolbar.append(a);
			}
			function encloseSelection(prefix, suffix, opts) {
				var opts = $.extend({
					affects_whole_line_only: false,
					replace_fn: function(prefix, sel, suffix) {
						return prefix + sel + suffix;
					},
					do_selection: false
				}, opts);

				textarea.focus();

				var start, end, sel, scrollPos, subst;

				start = textarea.selectionStart;
				end = textarea.selectionEnd;

				if (opts.affects_whole_line_only) {
					var textarea_val = $(textarea).val(), found_new_line = false;

					for (var i=start; i > 0; i--) {
						if (textarea_val[i]=='\n' || textarea_val[i]=='\r') {
							start = i + 1;
							found_new_line = true;
							break;
						}
					}
					if (!found_new_line) {
						start = 0;
					}

					found_new_line = false;
					for (var i=end; i < textarea_val.length; i++) {
						if (textarea_val[i]=='\n' || textarea_val[i]=='\r') {
							end = i;
							found_new_line = true;
							break;
						}
					}

					if (!found_new_line) {
						end = textarea_val.length;
					}

				}

				scrollPos = textarea.scrollTop;
				sel = textarea.value.substring(start, end);

				if (sel.match(/ $/)) { // exclude ending space char, if any
					sel = sel.substring(0, sel.length - 1);
					suffix = suffix + " ";
				}


				subst = opts.replace_fn(prefix, sel, suffix);

				textarea.value = textarea.value.substring(0, start) + subst + textarea.value.substring(end);

				if (opts.do_selection && sel) {
					textarea.setSelectionRange(start, end);
				} else {
					textarea.setSelectionRange(start + prefix.length, start + prefix.length);
				}


				textarea.scrollTop = scrollPos;
			}

			function replace_line_start(prefix, sel, suffix) {
				if (sel.length=='') {
					return suffix;
				}
				return sel.replace(/^(.*)$/mg, prefix + "$1");
			}

			addButton("strong", 'b', "Bold text: **Example**", function() {
				encloseSelection("**", "**");
			}, "<i class='icon icon-bold'></i>");

			addButton("quote", 'i', "Blockquote: > Example", function() {
				encloseSelection("> ", "> Blockquote\n\n", {
					affects_whole_line_only: true,
					replace_fn: replace_line_start
				});
			}, "<svg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M7.7125 9.26402L9.3865 5.83602H6.8355V0.736023H11.9355V5.83602L10.2625 9.26402H7.7125ZM0.8985 9.26402L2.6115 5.83602H0.0625V0.736023H5.1625V5.83602L3.4455 9.26402H0.8985Z' fill='currentColor'/> </svg>");

			addButton('emergency', null, 'Emergency tag: !emergency', function() {
				encloseSelection("\n!emergency\n", "");
			}, "<i class='icon icon-alert-triangle'></i>");

			addButton("code", 'k', "Code block: ``` example ```", function() {
				encloseSelection("\n```\n", "\n```\n");
			}, "<i class='icon icon-code'></i>");

			addButton("ul", 'u', "Unordered list", function() {
				encloseSelection(" * ", "\n * \n * \n\n", {
					affects_whole_line_only: true,
					replace_fn: replace_line_start,
					do_selection: false
				});
			}, "<i class='icon icon-list'></i>");

			addButton("оl", 'o', "Ordered list", function() {
				encloseSelection(" 0. ", "\n 0. \n 0. \n\n", {
					affects_whole_line_only: true,
					replace_fn: replace_line_start,
					do_selection: false
				});
			}, "<svg width='18' height='12' viewBox='0 0 18 12' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M16.2868 5.46H6.49475C6.29584 5.46 6.10507 5.53902 5.96442 5.67967C5.82377 5.82032 5.74475 6.01109 5.74475 6.21C5.74475 6.40891 5.82377 6.59968 5.96442 6.74033C6.10507 6.88098 6.29584 6.96 6.49475 6.96H16.2868C16.4857 6.96 16.6764 6.88098 16.8171 6.74033C16.9577 6.59968 17.0368 6.40891 17.0368 6.21C17.0368 6.01109 16.9577 5.82032 16.8171 5.67967C16.6764 5.53902 16.4857 5.46 16.2868 5.46ZM16.2868 10.085H6.49475C6.29584 10.085 6.10507 10.164 5.96442 10.3047C5.82377 10.4453 5.74475 10.6361 5.74475 10.835C5.74475 11.0339 5.82377 11.2247 5.96442 11.3653C6.10507 11.506 6.29584 11.585 6.49475 11.585H16.2868C16.4857 11.585 16.6764 11.506 16.8171 11.3653C16.9577 11.2247 17.0368 11.0339 17.0368 10.835C17.0368 10.6361 16.9577 10.4453 16.8171 10.3047C16.6764 10.164 16.4857 10.085 16.2868 10.085ZM6.49475 2.262H16.2868C16.3852 2.262 16.4828 2.2426 16.5738 2.20491C16.6648 2.16722 16.7474 2.11197 16.8171 2.04233C16.8867 1.97269 16.942 1.89001 16.9797 1.79901C17.0174 1.70802 17.0368 1.61049 17.0368 1.512C17.0368 1.41351 17.0174 1.31598 16.9797 1.22499C16.942 1.13399 16.8867 1.05131 16.8171 0.98167C16.7474 0.912026 16.6648 0.856781 16.5738 0.81909C16.4828 0.781399 16.3852 0.762 16.2868 0.762H6.49475C6.29584 0.762 6.10507 0.841018 5.96442 0.98167C5.82377 1.12232 5.74475 1.31309 5.74475 1.512C5.74475 1.71091 5.82377 1.90168 5.96442 2.04233C6.10507 2.18298 6.29584 2.262 6.49475 2.262ZM3.70675 9.676C3.85076 9.49781 3.96892 9.30019 4.05775 9.089C4.13343 8.89559 4.1721 8.68969 4.17175 8.482C4.17536 8.30177 4.14068 8.12283 4.07 7.95699C3.99933 7.79116 3.89426 7.64222 3.76175 7.52C3.45914 7.25354 3.06445 7.11576 2.66175 7.136C2.28247 7.12386 1.91004 7.23897 1.60375 7.463C1.44746 7.59723 1.32072 7.76243 1.23156 7.94816C1.1424 8.13389 1.09275 8.3361 1.08575 8.542L1.06875 8.692L2.19475 8.804L2.20475 8.65C2.20102 8.49878 2.24782 8.35063 2.33775 8.229C2.42275 8.15864 2.52935 8.11965 2.63969 8.11856C2.75002 8.11747 2.85737 8.15434 2.94375 8.223C2.98072 8.2665 3.00861 8.31695 3.02578 8.3714C3.04295 8.42584 3.04906 8.48316 3.04375 8.54C3.03821 8.69114 2.98811 8.83726 2.89975 8.96C2.69927 9.20424 2.47812 9.43074 2.23875 9.637C1.87745 9.94898 1.55752 10.3059 1.28675 10.699C1.12339 10.9682 1.02099 11.27 0.98675 11.583L0.96875 11.75H4.16875V10.684H2.68375C2.75875 10.604 2.91475 10.455 3.14775 10.241C3.34749 10.0664 3.53432 9.8776 3.70675 9.676ZM2.37475 1.929V4.861H3.49775V0.25H2.57475L2.53875 0.35C2.44492 0.597266 2.28172 0.8122 2.06875 0.969C1.87357 1.1304 1.65244 1.25754 1.41475 1.345L1.31475 1.379V2.441L1.51475 2.376C1.82338 2.27373 2.11371 2.12283 2.37475 1.929Z' fill='currentColor'/> </svg>");

			addButton("hr", 'r', "Horizontal rule: ----", function() {
				encloseSelection("\n----\n", "");
			}, "<i class='icon icon-minus'></i>");

			addButton("heading", 'h', "Heading: # Example", function() {
				encloseSelection("# ", "");
			}, "<i class='icon icon-type'></i>");

			var user_color = $(textarea).siblings('input[name="user_color"]:eq(0)').val();

			if (opts.preview) {
				addButton("preview", 'p', "Preview", function() {
                    $.post('/markdown-htmlize', {
						plain_text: $(textarea).val()
					}, function(r) {
							const tpl = `<li class="comment comment-preview" id="previewed_comment">
								<div class="comment__inner">
									<div class="comment-head">
										<div class="comment-head__title">
											<img src="${preview_user_avatar_url}" width="40" height="40" class="gravatar comment-avatar">
						
											<strong class="from">${preview_user_name}</strong>
										</div>
									</div>
								
									<div class="comment-body">
										<div class="comment-entry rte">${r}</div>
									</div>	
								</div>
							</li>`;
					
							if ($('#previewed_comment').length) {
								$('#previewed_comment').remove();
							}
							$('#comments').append(tpl);
						}
					)
					return false;
				}, "<i class='icon icon-eye'></i>");
			}

			$(textarea).siblings('.submit-comment-actions').append(toolbar);

			toolbar.append('<small class="comment-syntax-hint">syntax: <a href="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet" target="_blank">markdown</a></small>');
		});
	}
})(jQuery);
